import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "modal",
    "planName",
    "planPrice",
    "planCredits",
    "confirmButton",
    "form",
  ];

  open(event) {
    event.preventDefault();
    // Retrieve values from the link's data attributes
    const planCredits = event.currentTarget.dataset.planCredits;
    const planPrice = event.currentTarget.dataset.planPrice;
    const planUrl = event.currentTarget.dataset.planUrl;

    // Inject dynamic info into modal
    this.planNameTarget.textContent = `${planCredits} Credits / Month`;
    this.planPriceTarget.textContent = planPrice;
    this.planCreditsTarget.textContent = planCredits;

    // Dynamically set the form action to the subscription path
    // This way, the form POSTs to the correct plan URL
    this.formTarget.action = planUrl;

    // Show the modal
    this.modalTarget.classList.remove("hidden");
  }

  close() {
    // Hide the modal
    this.modalTarget.classList.add("hidden");
  }

  confirmClick(event) {
    // Disable the button to prevent double-click
    //event.currentTarget.disabled = true
    event.currentTarget.classList.add("pointer-events-none", "opacity-50");
    event.currentTarget.value = "Processing...";
  }
}
